import { useId as r } from "react";
const e = () => r();
export {
  e as useErrorId
};
//# sourceMappingURL=useErrorId.js.map
